const h1Style = {
    color: "grey"
  };
 export {
     h1Style,
 }  